import React, { useEffect, useRef } from 'react';
import '../styles/CloudPotential.css';
import potentialImg from './../../../../assets/solutions/cloudadoption/potential.png';


const PotentialSection = () => {
    const textRef = useRef(null);
    const imageRef = useRef(null);

    useEffect(() => {
        const elements = [textRef.current, imageRef.current];
        const options = { threshold: 0.1 };

        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                    observer.unobserve(entry.target);
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);

        elements.forEach(el => {
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;

            if (rect.top <= windowHeight * 0.9) {
                setTimeout(() => el.classList.add('animate'), 50);
            } else {
                observer.observe(el);
            }
        });

        return () => observer.disconnect();
    }, []);

    return (
        <section className="combine-section">
            <div className="share-container">
                <div className="potential-container">
                    <div className="potential-image" ref={imageRef}>
                        <img src={potentialImg} alt="Potential Visual" />
                    </div>
                    <div className="potential-text" ref={textRef}>
                        <h1>Move your business to the cloud with confidence. </h1>
                        <p>
                            With a team of cloud-certified architects, our cloud adoption and migration services help you transition seamlessly, securely, and efficiently - tailored to your business goals.
                        </p>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default PotentialSection;
